import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'

type V2BriefingGuidanceHelpTriggerProps = {
  guidanceBase: string
}

export function V2BriefingGuidanceHelpTrigger({
  guidanceBase,
}: V2BriefingGuidanceHelpTriggerProps) {
  const { t } = useTranslation('common')
  const title = t(`${guidanceBase}.title`)
  const intro = t(`${guidanceBase}.intro`)
  const snapshotItems = t(`${guidanceBase}.items`, { returnObjects: true })
  const items = Array.isArray(snapshotItems)
    ? snapshotItems.filter((item) => typeof item === 'string')
    : []

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type='button'
          className='inline-flex text-muted-foreground/70 hover:text-muted-foreground'
          aria-label={title}
        >
          <CircleHelp className='size-3.5' aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align='start'
        className='max-h-96 w-80 overflow-y-auto p-4'
      >
        <p className='text-sm font-medium'>{title}</p>
        <p className='mt-2 text-xs text-muted-foreground'>{intro}</p>
        {items.length > 0 ? (
          <ul className='mt-2 list-disc space-y-0.5 ps-4 text-xs text-muted-foreground'>
            {items.map((item, itemIndex) => (
              <li key={`${guidanceBase}-${itemIndex}`}>{item}</li>
            ))}
          </ul>
        ) : null}
      </PopoverContent>
    </Popover>
  )
}
